export default __webpack_public_path__ + "static/media/io.e3e96cdc.svg";